import { endPoint } from "./base.config";

export const paymentPackages = {
  fetchAll: `${endPoint}payment-packages`,
}